import styled from 'styled-components';
import Button from '@prisjakt/ui-button';

export const CreateListButton = styled(Button)`
  background-color: ${p => p.theme.bg.primary};

  &:hover {
    background-color: #d5e3eb; /* Outlined primary transparent background color in hex */
  }
`;
